angular.module("app").controller("EditSkinGameWinnersPageController", [
    '$scope',
    'preloadedList',
    function ($scope, preloadedList) {
        ;
    }
]);